import React, { useEffect, useState } from "react";
import { X, Share, Plus, Smartphone } from "lucide-react";

const DISMISS_KEY = "epaycash_a2hs_dismissed";

function isMobile() {
  if (typeof window === "undefined") return false;
  return /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent) || window.innerWidth < 768;
}
function isIOS() {
  if (typeof window === "undefined") return false;
  return /iPhone|iPad|iPod/i.test(window.navigator.userAgent);
}
function isStandalone() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

export default function A2HSBanner() {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    try {
      if (!isMobile()) return;
      if (isStandalone()) return;
      if (localStorage.getItem(DISMISS_KEY) === "1") return;
      setIos(isIOS());
      setVisible(true);
    } catch (_) { /* ignore */ }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch (_) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="m-a2hs mb-4 relative" data-testid="a2hs-banner" role="dialog" aria-label="Add to home screen">
      <button
        onClick={dismiss}
        className="absolute top-2 right-2 h-8 w-8 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center text-white"
        aria-label="Dismiss"
        data-testid="a2hs-dismiss"
      >
        <X className="h-4 w-4" />
      </button>

      <div className="flex items-start gap-3 pr-10">
        <div className="h-10 w-10 rounded-xl bg-white/20 flex items-center justify-center shrink-0">
          <Smartphone className="h-5 w-5 text-white" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-bold text-sm">Add EPAYCASH to Home Screen</div>
          <div className="text-xs opacity-90 mt-0.5">Faster access, app-like experience. No download needed.</div>
          {!expanded && (
            <button
              onClick={() => setExpanded(true)}
              className="mt-2 inline-flex items-center gap-1 text-xs font-semibold bg-white/20 hover:bg-white/30 rounded-full px-3 py-1.5"
              data-testid="a2hs-show-steps"
            >
              Show steps →
            </button>
          )}
          {expanded && (
            <div className="mt-3 bg-white/15 rounded-xl p-3 text-xs space-y-2">
              {ios ? (
                <div>
                  <div className="font-semibold mb-1 flex items-center gap-1.5">iPhone (Safari)</div>
                  <ol className="list-decimal list-inside space-y-0.5 opacity-95">
                    <li>Tap the <Share className="h-3.5 w-3.5 inline mx-0.5" /> Share button</li>
                    <li>Scroll and select <b>"Add to Home Screen"</b></li>
                    <li>Tap <b>Add</b> in the top-right corner</li>
                  </ol>
                </div>
              ) : (
                <div>
                  <div className="font-semibold mb-1">Android (Chrome)</div>
                  <ol className="list-decimal list-inside space-y-0.5 opacity-95">
                    <li>Tap the <b>⋮</b> menu (top-right)</li>
                    <li>Choose <b>"Add to Home screen"</b> or <b>"Install app"</b></li>
                    <li>Tap <b><Plus className="h-3.5 w-3.5 inline" /> Add</b></li>
                  </ol>
                </div>
              )}
              <div className="flex gap-2 pt-1">
                <button onClick={dismiss} className="text-xs font-semibold bg-white text-indigo-700 rounded-full px-3 py-1.5" data-testid="a2hs-got-it">Got it</button>
                <button onClick={() => setExpanded(false)} className="text-xs font-semibold bg-white/20 hover:bg-white/30 rounded-full px-3 py-1.5">Hide</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
